import { graphql } from 'gatsby';
import { useStaticQuery } from 'gatsby';
import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import { IStaticContentfulImages } from 'src/types/contentful';
import { LearnMoreStack } from './ProductsMegaMenu.styles';
import MegaMenuLearnMore from 'src/app/molecules/Header/MegaMenu/MegaMenuLearnMore';

const ProductsMegaMenuLearnMore = (): JSX.Element => {
  const { spotlight, pro } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      spotlight: contentfulAsset(contentful_id: { eq: "5f0bwjSzuESRoMrJSGuLvv" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 300)
      }
      pro: contentfulAsset(contentful_id: { eq: "C6wuNpNIJfMyDkbbewHVq" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 300)
      }
    }
  `);

  const learnMoreLinks = [
    {
      image: spotlight.gatsbyImageData,
      alt: 'Spotlight',
      title: 'Mighty Spotlight',
      description: "The stories behind the world's most interesting and impactful communities.",
      href: '/case-studies',
    },
    {
      image: pro.gatsbyImageData,
      alt: 'Pro',
      title: 'Mighty Pro',
      description: 'Get your own branded apps and the expert support you need to launch and grow.',
      href: '/pro',
    },
  ];

  return (
    <LearnMoreStack
      direction='column'
      align='flex-start'
      justify='flex-start'
      gap={'spacing-lg'}
      borderRadius={'radius-2xl'}
      background='bg-secondary'
      padding={['spacing-3xl', 'spacing-4xl', 'spacing-3xl', 'spacing-3xl']}
    >
      <Typography
        type='paragraph'
        size='sm'
        fontWeight='font-weight-semibold'
        color='text-brand-secondary'
      >
        Resources
      </Typography>
      <Stack
        direction='column'
        align='flex-start'
        justify='flex-start'
        gap='spacing-xxs'
      >
        {learnMoreLinks.map((link) => (
          <MegaMenuLearnMore
            key={link.title}
            {...link}
          />
        ))}
      </Stack>
    </LearnMoreStack>
  );
};

export default ProductsMegaMenuLearnMore;
